// Single submission guard shared across all localization forms
let mLocalizationSubmitting = false;
let mLocalizationResetTimer = null;

if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector("[data-localization-select]");
      if (!select) return;

      select.addEventListener("change", () => {
        const value = select.value;
        const form = select.closest("[data-localization-form]");
        if (!form || !value) return;

        // Avoid duplicate submits from this form or others
        if (mLocalizationSubmitting || form.dataset.submitting === "true")
          return;

        const input = form.querySelector("input[data-localization-input]");
        if (!input) return;

        const current = input.value || input.getAttribute("value");
        if (current === value) return;

        // Update hidden input and ensure return path is preserved
        input.value = value;
        input.setAttribute("value", value);

        let returnTo = form.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement("input");
          returnTo.type = "hidden";
          returnTo.name = "return_to";
          form.appendChild(returnTo);
        }
        returnTo.value = window.location.pathname + window.location.search;

        // Flag submission and lock further interactions
        form.dataset.submitting = "true";
        mLocalizationSubmitting = true;
        select.disabled = true;

        if (!form.getAttribute("method")) {
          form.setAttribute("method", "post");
        }

        form.submit();

        // Safety reset if navigation is blocked
        clearTimeout(mLocalizationResetTimer);
        mLocalizationResetTimer = setTimeout(() => {
          mLocalizationSubmitting = false;
          form.dataset.submitting = "false";
          select.disabled = false;
        }, 5000);
      });
    }
  }
  customElements.define("m-localization-form", MLocalizationForm);
}
